/**
 * Email address validation for form answers.
 * Keep in sync with Portal-Backend/services/emailValidation.js
 */

const MAX_EMAIL_LENGTH = 254;

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function normalizeEmail(raw: unknown): string {
  return String(raw ?? "").trim().toLowerCase();
}

export type EmailValidationResult =
  | { ok: true; normalized: string }
  | { ok: false; message: string };

export function validateEmail(raw: unknown): EmailValidationResult {
  const normalized = normalizeEmail(raw);

  if (!normalized) {
    return { ok: false, message: "Enter a valid email address." };
  }

  if (normalized.length > MAX_EMAIL_LENGTH) {
    return { ok: false, message: "Email address is too long." };
  }

  if (!EMAIL_PATTERN.test(normalized)) {
    return {
      ok: false,
      message: "Enter a valid email address (name@example.com).",
    };
  }

  return { ok: true, normalized };
}
